<template>
  <tr>
    <td>
      {{ index + 1 }}
    </td>
    <td>
      {{ item.factoryMarking }}
    </td>
    <td>
      <span v-if="item.manufacturer">{{ item.manufacturer.title }}</span>
      <span
        v-else
        class="red accent-1"
      >{{ item.manufacturerOrigin }}</span>
    </td>
    <td>
      <span v-if="item.trademark">{{ item.trademark.title }}</span>
      <span
        v-else
        class="red accent-1"
      >{{ item.trademarkOrigin }}</span>
    </td>
    <td>
      <span v-if="item.model">{{ item.model.title }}</span>
      <span
        v-else
        class="red accent-1"
      >{{ item.modelOrigin }}</span>
    </td>
    <td>
      <span v-if="item.article">{{ item.article.title }}</span>
      <span
        v-else
        class="red accent-1"
      >{{ item.articleOrigin }}</span>
    </td>
    <td>
      <span v-if="item.nomenclature">{{ item.nomenclature.title }}</span>
      <span
        v-else
        class="red accent-1"
      >{{ item.nomenclatureOrigin }}</span>
    </td>
    <td>
      {{ item.material }}
    </td>
    <td>
      {{ item.size }}
    </td>
    <td>
      <span v-if="item.country">{{ item.country.title }}</span>
      <span
        v-else
        class="red accent-1"
      >{{ item.countryOrigin }}</span>
    </td>
    <td>
      <span v-if="item.quantity">{{ item.quantity }}</span>
      <span
        v-else
        class="red accent-1"
      >{{ item.quantityOrigin }}</span>
    </td>
    <td>
      <span v-if="item.unit">{{ item.unit.title }}</span>
      <span
        v-else
        class="red accent-1"
      >{{ item.unitOrigin }}</span>
    </td>
    <td>
      <span v-if="item.weightNetto">{{ item.weightNetto }}</span>
      <span
        v-else
        class="red accent-1"
      >{{ item.weightNettoOrigin }}</span>
    </td>
    <td>
      <span v-if="item.weightBrutto">{{ item.weightBrutto }}</span>
      <span
        v-else
        class="red accent-1"
      >{{ item.weightBruttoOrigin }}</span>
    </td>
    <td>
      <span v-if="item.places">{{ item.places }}</span>
      <span
        v-else
        class="red accent-1"
      >{{ item.placesOrigin }}</span>
    </td>
    <td>
      <span v-if="item.volume">{{ item.volume }}</span>
      <span
        v-else
        class="red accent-1"
      >{{ item.volumeOrigin }}</span>
    </td>
    <td>
      <span v-if="item.cost">{{ item.cost }}</span>
      <span
        v-else
        class="red accent-1"
      >{{ item.costOrigin }}</span>
    </td>
    <td>
      <span v-if="item.currency">{{ item.currency.title }}</span>
      <span
        v-else
        class="red accent-1"
      >{{ item.currencyOrigin }}</span>
    </td>
    <td>
      {{ item.goodSite }}
    </td>
    <td>
      {{ item.customsNumber }}
    </td>
    <td>
      <span v-if="item.productCategory">{{ item.productCategory.title }}</span>
      <span
        v-else
        class="red accent-1"
      >{{ item.productCategoryOrigin }}</span>
    </td>
    <td>
      {{ item.notes }}
    </td>
  </tr>
</template>

<script>
export default {
  props: ["item", "index"],
};
</script>
